// extracted by mini-css-extract-plugin
export var actionButton = "_q0-0";
export var actionMenuContainer = "_q0-i";
export var bubble = "_q0-2";
export var bubbleActionMenu = "_q0-j";
export var bubbleContext = "_q0-6";
export var bubbleItems = "_q0-7";
export var customer = "_q0-3";
export var divider = "_q0-8";
export var fileList = "_q0-9";
export var hiddenComment = "_q0-o";
export var infoAbove = "_q0-a";
export var internal = "_q0-4";
export var lightActionButton = "_q0-1";
export var link = "_q0-b";
export var merchant = "_q0-5";
export var message = "_q0-c";
export var profilePicture = "_q0-e";
export var quillToolbarContainer = "_q0-f";
export var senderDate = "_q0-g";
export var senderDateCustomer = "_q0-h";
export var senderName = "_q0-d";
export var time = "_q0-k";
export var uploadedImage = "_q0-l";
export var username = "_q0-m";
export var xsmall = "_q0-n";